module.exports = __webpack_public_path__ + "img/logo.51a6c98b.png";